/* Contact page — progressive enhancement only.
   1. Topic-hint swap under the subject select.
   2. Triage cards open their target <details> expander.
   3. Card/expander links preselect the matching form topic.
   The page functions fully with JS disabled (anchors still jump,
   the form still posts; hints are simply absent). No customer data
   is read or stored here. */

(function () {

  function updateHint(select) {
    var hint = document.querySelector('[data-contact-topic-hint]');
    if (!hint) return;
    var option = select.options[select.selectedIndex];
    var text = option ? option.getAttribute('data-hint') : null;
    if (text) {
      hint.textContent = text;
      hint.hidden = false;
    } else {
      hint.hidden = true;
    }
  }

  function selectTopic(label) {
    var select = document.querySelector('[data-contact-topic-select]');
    if (!select || !label) return;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === label) {
        select.selectedIndex = i;
        updateHint(select);
        return;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {

    var select = document.querySelector('[data-contact-topic-select]');
    if (select) {
      select.addEventListener('change', function () {
        updateHint(select);
      });
    }

    // ?topic= deep link
    try {
      var param = new URLSearchParams(window.location.search).get('topic');
      if (param) selectTopic(param);
    } catch (e) { /* older browsers: anchors still work */ }

    // Mobile list: each expand panel sits under its row so it opens in
    // place; desktop keeps panels after the card grid.
    var placePanels = function () {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      document.querySelectorAll('details.bs-expander').forEach(function (d) {
        var card = document.querySelector('[href="#' + d.id + '"]');
        if (!card) return;
        if (mobile) card.insertAdjacentElement('afterend', d);
        else card.parentElement.appendChild(d);
      });
    };
    placePanels();
    window.addEventListener('resize', placePanels);

    // One expander open at a time
    var expanders = document.querySelectorAll('details.bs-expander');
    expanders.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          expanders.forEach(function (other) {
            if (other !== d) other.removeAttribute('open');
          });
        }
      });
    });

    // Triage cards: open the target expander; topic links preselect
    document.querySelectorAll('[data-contact-topic], [data-contact-expander-target]').forEach(function (el) {
      el.addEventListener('click', function () {
        var topic = el.getAttribute('data-contact-topic');
        if (topic) selectTopic(topic);

        // Prefill the message with the order reference — never overwrite
        // anything the visitor already typed
        var prefill = el.getAttribute('data-contact-prefill');
        if (prefill) {
          var ta = document.querySelector('#contact-form textarea[name="contact[body]"]');
          if (ta && !ta.value.trim()) ta.value = prefill;
        }

        var href = el.getAttribute('href') || '';
        if (href.charAt(0) === '#') {
          var target = document.getElementById(href.slice(1));
          if (target) {
            if (target.tagName === 'DETAILS') target.setAttribute('open', '');
            if (typeof target.scrollIntoView === 'function') {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }
      });
    });

  });

})();
